import * as React from 'react';
import { getUserApi, signUpApi } from '../api/api';
import { useNavigate } from 'react-router-dom';
import RegistrationForm from '../features/registration/RegistrationForm';
import { useUserStore } from '../stores/use-user-store';

const Registration = () => {
  const { setUser, setAuthorized } = useUserStore();

  const navigate = useNavigate();
  const [_res, _setRes] = React.useState({});

  const handleSubmit = async (data) => {
    const { termsOfUse, personalData, name, organization, ...rest } = data;
    const formData = {
      ...rest,
      organization: {
        ...organization,
        username: name,
      },
      redirect_link: process.env.REACT_APP_REDIRECT_LINK + 'verify',
    };

    await signUpApi(
      formData,
      async function (data) {},
      function (err) {
        // ошибка на бэке неверная (временный костыль):
        if (err?.error === 'слишком короткий пароль') {
          _setRes({ error: 'Пароль небезопасен или слишком короткий. Попробуйте уменьшить повторения одних и тех же символов' });
        } else {
          _setRes(err);
        }
      }
    );

    await getUserApi(
      function (data) {
        setUser(data);
        setAuthorized(true);
        navigate('/user');
      },
      function (err) {
        setAuthorized(false);
      }
    );
  };

  /** initial data: **/
  const inputsFields = [
    { name: 'name', label: 'Название организации', placeholder: 'Укажите название организации', type: 'text', autoComplete: 'off', maxLength: 50 },
    { name: 'organization.inn', label: 'ИНН', placeholder: 'Укажите ИНН', type: 'text', maxLength: 50 },
    {
      name: 'organization.email',
      label: 'Email',
      placeholder: 'someone@example.com',
      type: 'email',
      autoComplete: 'email',
      maxLength: 255,
    },
    {
      name: 'organization.password',
      label: 'Пароль',
      placeholder: 'Придумайте пароль',
      type: 'password',
    },
  ];

  return <RegistrationForm containerClass={'border-b border-x border-gray-300'} fields={inputsFields} handleSubmit={handleSubmit} error={_res?.error} />;
};

export default Registration;
